import { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const ArticlePage = lazy(() => import("../pages/blog/article/page"));
const CategoryPage = lazy(() => import("../pages/blog/categoria/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));
const TermosDeUsoPage = lazy(() => import("../pages/termos-de-uso/page"));
const CartasDisponiveisPage = lazy(() => import("../pages/cartas-disponiveis/page"));
const SimuladorPage = lazy(() => import("../pages/simulador/page"));
const QuemSomosPage = lazy(() => import("../pages/quem-somos/page"));
const GlossarioPage = lazy(() => import("../pages/glossario/page"));
const FAQPage = lazy(() => import("../pages/faq/page"));
const ConsorcioImovelPage = lazy(() => import("../pages/consorcio-contemplado-imovel/page"));
const ConsorcioVeiculoPage = lazy(() => import("../pages/consorcio-contemplado-veiculo/page"));
const CalculadoraEconomiaPage = lazy(() => import("../pages/calculadora-de-economia/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-800"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: "/blog",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <BlogPage />
      </Suspense>
    ),
  },
  {
    path: "/blog/:slug",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ArticlePage />
      </Suspense>
    ),
  },
  {
    path: "/blog/categoria/:categorySlug",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CategoryPage />
      </Suspense>
    ),
  },
  {
    path: "/cartas-disponiveis",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CartasDisponiveisPage />
      </Suspense>
    ),
  },
  {
    path: "/simulador",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SimuladorPage />
      </Suspense>
    ),
  },
  {
    path: "/quem-somos",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <QuemSomosPage />
      </Suspense>
    ),
  },
  {
    path: "/glossario",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <GlossarioPage />
      </Suspense>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <PrivacyPolicyPage />
      </Suspense>
    ),
  },
  {
    path: "/termos-de-uso",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <TermosDeUsoPage />
      </Suspense>
    ),
  },
  {
    path: "/faq",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <FAQPage />
      </Suspense>
    ),
  },
  {
    path: "/consorcio-contemplado-imovel",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ConsorcioImovelPage />
      </Suspense>
    ),
  },
  {
    path: "/consorcio-contemplado-veiculo",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ConsorcioVeiculoPage />
      </Suspense>
    ),
  },
  {
    path: "/calculadora-de-economia",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CalculadoraEconomiaPage />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
